import { render, staticRenderFns } from "./SettingsFollowDepartmentMenu.vue?vue&type=template&id=16130e6c&scoped=true&"
import script from "./SettingsFollowDepartmentMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsFollowDepartmentMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsFollowDepartmentMenu.vue?vue&type=style&index=0&id=16130e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16130e6c",
  null
  
)

export default component.exports